var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#737680","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M12 9v13M15 19l-3 3-3-3M17 16h2c2.209 0 4-1.791 4-4 0-2.197-1.782-4.013-4.025-3.997C18.718 4.093 15.474 1 11.5 1 7.481 1 4.21 4.164 4.018 8.136 2.287 8.575 1 10.132 1 12c0 2.209 1.791 4 4 4h2"}));
}

Download.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Download;

Download.default = Download;
